export default __webpack_public_path__ + "static/media/sideLogo.92c1ca1b.png";